var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('app-bar',_vm._l((_vm.apps),function(app,index){return _c('app-link',_vm._b({key:index,attrs:{"title":app.label}},'app-link',app.link,false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }